import { View } from "react-native-web";
import { CImage } from "../../../components/atoms";
import { Constants, Images } from "../../../config";

export const spaFilterCriteria = (isMobileVersion, styles) => {
  return [
    {
      title: "Location",
      isHide: isMobileVersion,
      isLocation: true,
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_VENUE,
      icon: Images.iconTagGeneral,
      width: 20,
      height: 20,
      title: "Venue",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Spa",
          tagId: 707,
        },
        {
          id: 2,
          label: "Hotel",
          tagId: 708,
        },
        {
          id: 3,
          label: "Club",
          tagId: 701,
        },
        {
          id: 4,
          label: "Other",
          tagId: 706,
        },
        {
          id: null,
          label: null,
          isSeparator: true,
        },
        {
          id: 8,
          label: "Indoor Only",
          tagId: 802,
        },
        {
          id: 9,
          label: "Outdoor Only",
          tagId: 803,
        },
        {
          id: 7,
          label: "Indoor & Outdoor",
          tagId: 801,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_AREA,
      icon: Images.iconTagArea,
      width: 20,
      height: 20,
      title: "Area",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "City",
          tagId: 901,
        },
        {
          id: 2,
          label: "Town",
          tagId: 902,
        },
        {
          id: 3,
          label: "Countryside",
          tagId: 903,
        },
        {
          id: 4,
          label: "Field",
          tagId: 904,
        },
        {
          id: 5,
          label: "Forest",
          tagId: 905,
        },
        {
          id: 6,
          label: "Lake",
          tagId: 906,
        },
        {
          id: 7,
          label: "Beach",
          tagId: 907,
        },
        {
          id: 8,
          label: "Mountain",
          tagId: 908,
        },
        {
          id: 9,
          label: "Park",
          tagId: 909,
        },
        {
          id: 10,
          label: "Resort",
          tagId: 910,
        },
        {
          id: 11,
          label: "Unique Location",
          tagId: 911,
        },
        {
          id: 12,
          label: "Ship",
          tagId: 912,
        },
        {
          id: 13,
          label: "Other",
          tagId: 913,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_FEATURES,
      icon: Images.iconTagLightning,
      width: 20,
      height: 20,
      title: "Features",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Day Spa",
          tagId: 631,
        },
        {
          id: 2,
          label: "Destination Spa",
          tagId: 632,
        },
        {
          id: 3,
          label: "Thermal Spa",
          tagId: 633,
        },
        {
          id: 4,
          label: "Hotel Spa",
          tagId: 634,
        },
        {
          id: 5,
          label: "Club Spa",
          tagId: 635,
        },
        {
          id: 6,
          label: "Medical Spa",
          tagId: 637,
        },
        {
          id: 7,
          label: "Adults Only",
          tagId: 638,
        },
        {
          id: 8,
          label: "Luxury",
          tagId: 639,
        },
        {
          id: 9,
          label: "Rooftop",
          tagId: 609,
        },
        {
          id: 10,
          label: "Basement",
          tagId: 629,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_FACILITIES,
      icon: Images.iconTagView,
      width: 20,
      height: 20,
      title: "Facilities",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Indoor Pool",
          tagId: 2601,
        },
        {
          id: 2,
          label: "Outdoor Pool",
          tagId: 2602,
        },
        {
          id: 3,
          label: "Hot Tub",
          tagId: 2603,
        },
        {
          id: 4,
          label: "Outdoor Hot Tub",
          tagId: 2604,
        },
        {
          id: 5,
          label: "Sauna",
          tagId: 2605,
        },
        {
          id: 6,
          label: "Steam Room",
          tagId: 2606,
        },
        {
          id: 7,
          label: "Hydrotherapy Pool",
          tagId: 2607,
        },
        {
          id: 8,
          label: "Experience Showers",
          tagId: 2608,
        },
        {
          id: 9,
          label: "Ice Room / Fountain",
          tagId: 2609,
        },
        {
          id: 10,
          label: "Plunge Pool",
          tagId: 2610,
        },
        {
          id: 11,
          label: "Gym",
          tagId: 2611,
        },
        {
          id: 12,
          label: "Solarium",
          tagId: 2612,
        },
        {
          id: 13,
          label: "Relaxation Room",
          tagId: 2613,
        },
        {
          id: 14,
          label: "Other Rooms",
          tagId: 2614,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_TREATMENTS,
      icon: Images.iconTagParticipation,
      width: 20,
      height: 20,
      title: "Treatments",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Manicure",
          tagId: 2701,
        },
        {
          id: 2,
          label: "Massage",
          tagId: 2702,
        },
        {
          id: 3,
          label: "Facial",
          tagId: 2703,
        },
        {
          id: 5,
          label: "Pedicure",
          tagId: 2704,
        },
        {
          id: 6,
          label: "Body",
          tagId: 2705,
        },
        {
          id: 7,
          label: "Rasul",
          tagId: 2706,
        },
        {
          id: 8,
          label: "Rituals",
          tagId: 2707,
        },
        {
          id: 9,
          label: "Other",
          tagId: 2708,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_ROOFTOP_SIZE,
      icon: Images.iconTagSize,
      width: 20,
      height: 20,
      title: "Size",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "XS",
          suffix: "0-20",
          tagId: 2401,
        },
        {
          id: 2,
          label: "S",
          suffix: "21-50",
          tagId: 2402,
        },
        {
          id: 3,
          label: "M",
          suffix: "51-100",
          tagId: 2403,
        },
        {
          id: 4,
          label: "L",
          suffix: "101-200",
          tagId: 2404,
        },
        {
          id: 5,
          label: "XL",
          suffix: "201-500",
          tagId: 2405,
        },
        {
          id: 6,
          label: "XXL",
          suffix: "500+",
          tagId: 2406,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_PRICE_VENUE,
      icon: Images.iconTagPrice,
      width: 20,
      height: 20,
      title: "Price",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "1",
          tagId: 1501,
          prefixIcon: (
            <View style={styles.row}>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPriceGray}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPriceGray}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 0 : 3 }}>
                <CImage
                  source={Images.iconTagPriceGray}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
            </View>
          ),
        },
        {
          id: 2,
          label: "2",
          tagId: 1502,
          prefixIcon: (
            <View style={styles.row}>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPriceGray}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 0 : 3 }}>
                <CImage
                  source={Images.iconTagPriceGray}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
            </View>
          ),
        },
        {
          id: 3,
          label: "3",
          tagId: 1503,
          prefixIcon: (
            <View style={styles.row}>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 0 : 3 }}>
                <CImage
                  source={Images.iconTagPriceGray}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
            </View>
          ),
        },
        {
          id: 4,
          label: "4",
          tagId: 1504,
          prefixIcon: (
            <View style={styles.row}>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 0 : 3 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
            </View>
          ),
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_AMENITIES,
      icon: Images.iconTagAmenities,
      width: 20,
      height: 20,
      title: "Amenities",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Lounge / Bar",
          tagId: 33,
        },
        {
          id: 2,
          label: "Restaurant",
          tagId: 44,
        },
        {
          id: 3,
          label: "Nightclub",
          tagId: 45,
        },
        {
          id: 4,
          label: "Salon",
          tagId: 46,
        },
        {
          id: 5,
          label: "Golf",
          tagId: 47,
        },
        {
          id: 6,
          label: "Tennis",
          tagId: 48,
        },
        {
          id: 7,
          label: "Parking",
          tagId: 49,
        },
        {
          id: 8,
          label: "Accessibility",
          tagId: 50,
        },
        {
          id: 9,
          label: "Pet Friendly",
          tagId: 51,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_STATUS,
      icon: Images.iconTagStatus,
      width: 20,
      height: 20,
      title: "Status",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Open",
          tagId: 1,
        },
        {
          id: 2,
          label: "Closed",
          tagId: 2,
        },
        {
          id: 3,
          label: "Temporarily Closed",
          tagId: 4,
        },
        {
          id: 4,
          label: "Permanently Closed",
          tagId: 3,
        },
      ],
      selectedList: [1, 2, 4],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_RATING,
      icon: Images.iconTagRating,
      width: 21.5,
      height: isMobileVersion ? 21 : 20,
      title: "Rating",
      isHide: true,
      isRating: true,
      detailList: [
        {
          id: 1,
          label: "1",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating1}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 2,
          label: "2",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating2}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 3,
          label: "3",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating3}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 4,
          label: "4",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating4}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 5,
          label: "5",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating5}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
      ],
      selectedList: [],
    },
  ];
};
